import React from 'react';

import { Description as DescriptionIcon, Assignment as AssignmentIcon } from '@mui/icons-material';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

import type { ToggleViewType } from '@/apps/engagement-letter-database/data/types';

interface DashboardViewToggleProps {
  value: ToggleViewType;
  onChange: (value: ToggleViewType) => void;
}

const DashboardViewToggle = ({ value, onChange }: DashboardViewToggleProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: ToggleViewType | null) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <ToggleButtonGroup value={value} exclusive onChange={handleChange} color="primary">
        <ToggleButton value="related-clients">
          <DescriptionIcon sx={{ mr: 1 }} />
          Related Clients
        </ToggleButton>
        <ToggleButton value="clients">
          <AssignmentIcon sx={{ mr: 1 }} />
          Clients
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default DashboardViewToggle;
